// Werte müssen stele-definitions.scss entsprechen
/*eslint camelcase: 0 */
export const stele_height_vh = 85;
export const stele_ds_height_px = (726*8000)/8500*0.84; // (726*8000)/8500*0.95;

export const stele_height_mm = 3750; // Größe im Editor: man sieht nur das oberste Stück
export const stele_height_height_mm = 8000; // Gesamtgröße in Datenblatt und Höhenscreen: Man sieht die ganze Stele

export const stele2vh = stele_height_vh/(((3750*76)/1000.0)); // 3750 entspricht getStele in stele.jsx

export const svg2configbar = 0.5;
export const backgroundColor = 'rgb(222,222,222)'; //#dedede, entspricht Farbe von body
